/**
 * Latvian Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const lv: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Panelis',
  'nav.funds': 'Fondi',
  'nav.investments': 'Ieguldījumi',
  'nav.investees': 'Ieguldījumu saņēmēji',
  'nav.esg': 'ESG Pārskats',
  'nav.compliance': 'Atbilstība',
  'nav.reports': 'Atskaites',
  'nav.settings': 'Iestatījumi',
  'nav.users': 'Lietotāji',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Rādītāji',
  'nav.taxonomy': 'ES Taksonomija',
  'nav.filings': 'Iesniegumi',
  'nav.calendar': 'Kalendārs',
  'nav.submit': 'Iesniegt datus',
  'nav.submissions': 'Mani iesniegumi',
  'nav.benchmarks': 'Etaloni',
  'nav.messages': 'Ziņojumi',
  'nav.portfolio': 'Portfelis',
  'nav.performance': 'Fondu rezultāti',
  'nav.esgSummary': 'ESG Kopsavilkums',
  'nav.pipeline': 'Konveijers',
  'nav.dueDiligence': 'Pienācīga pārbaude',
  'nav.impact': 'Ietekmes rādītāji',
  'nav.sdg': 'IAM Kartēšana',
  'nav.audit': 'Revīzijas izsekošana',
  'nav.snapshots': 'Datu momentuzņēmumi',
  'nav.knowledgeGraph': 'Zināšanu grafs',
  'nav.geographic': 'Ģeogrāfiskais',
  'nav.bi': 'BI Studija',
  'nav.ai': 'AI Palīgs',
  'nav.tasks': 'Uzdevumi',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Regulatīvais monitors',

  // Common Actions
  'action.create': 'Izveidot',
  'action.edit': 'Rediģēt',
  'action.delete': 'Dzēst',
  'action.save': 'Saglabāt',
  'action.cancel': 'Atcelt',
  'action.submit': 'Iesniegt',
  'action.approve': 'Apstiprināt',
  'action.reject': 'Noraidīt',
  'action.download': 'Lejupielādēt',
  'action.export': 'Eksportēt',
  'action.import': 'Importēt',
  'action.filter': 'Filtrēt',
  'action.search': 'Meklēt',
  'action.refresh': 'Atsvaidzināt',
  'action.close': 'Aizvērt',
  'action.back': 'Atpakaļ',
  'action.next': 'Nākamais',
  'action.previous': 'Iepriekšējais',
  'action.viewAll': 'Skatīt visu',
  'action.viewDetails': 'Skatīt detaļas',
  'action.generate': 'Ģenerēt',
  'action.signOut': 'Izrakstīties',
  'action.addNew': 'Pievienot jaunu',
  'action.invite': 'Uzaicināt',

  // Statuses
  'status.draft': 'Melnraksts',
  'status.submitted': 'Iesniegts',
  'status.validated': 'Validēts',
  'status.approved': 'Apstiprināts',
  'status.rejected': 'Noraidīts',
  'status.pending': 'Gaida',
  'status.inProgress': 'Procesā',
  'status.overdue': 'Nokavēts',
  'status.compliant': 'Atbilstošs',
  'status.filed': 'Iesniegts',
  'status.active': 'Aktīvs',
  'status.inactive': 'Neaktīvs',
  'status.closed': 'Slēgts',
  'status.fundraising': 'Līdzekļu piesaiste',
  'status.investing': 'Ieguldīšana',
  'status.harvesting': 'Ievākšana',
  'status.validating': 'Validācija',
  'status.review': 'Pārskatīšanā',
  'status.monitoring': 'Monitorings',
  'status.exiting': 'Izeja',
  'status.pipeline': 'Pipeline',
  'status.due_diligence': 'Pienācīga pārbaude',
  'status.disbursed': 'Izmaksāts',
  'status.restructured': 'Pārstrukturēts',
  'status.matured': 'Termiņš beidzies',
  'status.written_off': 'Norakstīts',
  'status.exited': 'Izgājis',
  'status.incomplete': 'Nepilnīgs',
  'status.open': 'Atvērts',
  'status.in_progress': 'Procesā',
  'status.completed': 'Pabeigts',
  'status.cancelled': 'Atcelts',
  'status.accepted': 'Pieņemts',
  'status.failed': 'Neizdevās',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Portfeļa pārskats',
  'dashboard.complianceStatus': 'Atbilstības statuss',
  'dashboard.collectionProgress': 'Savākšanas progress',
  'dashboard.activityFeed': 'Aktivitāte',
  'dashboard.quickActions': 'Ātrās darbības',
  'dashboard.investmentPipeline': 'Ieguldījumu konveijers',
  'dashboard.totalFunds': 'Kopā fondi',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Aktīvie ieguldījumi',
  'dashboard.totalInvestees': 'Ieguldījumu saņēmēji',
  'dashboard.recentActivity': 'Nesenā aktivitāte',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Kopā apņemšanās',
  'lp.capitalCalled': 'Pieprasītais kapitāls',
  'lp.distributed': 'Sadalīts',
  'lp.netPosition': 'Neto pozīcija',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Fondu rezultāti',
  'lp.esgSummary': 'ESG Kopsavilkums',
  'lp.reportLibrary': 'Atskaišu bibliotēka',
  'lp.taxonomyAligned': 'Saskaņots ar taksonomiju',
  'lp.paiCoverage': 'PAI Pārklājums',
  'lp.portfolioPerformance': 'LP Portfeļa rezultāti',

  // Fund Labels
  'fund.name': 'Fonda nosaukums',
  'fund.code': 'Fonda kods',
  'fund.vintage': 'Dibināšanas gads',
  'fund.size': 'Fonda lielums',
  'fund.targetSize': 'Mērķa lielums',
  'fund.currency': 'Valūta',
  'fund.strategy': 'Stratēģija',
  'fund.status': 'Statuss',
  'fund.sfdrCategory': 'SFDR Kategorija',
  'fund.geographyFocus': 'Ģeogrāfiskais fokuss',
  'fund.sectorFocus': 'Nozares fokuss',

  // Form Labels
  'form.name': 'Nosaukums',
  'form.email': 'E-pasts',
  'form.country': 'Valsts',
  'form.amount': 'Summa',
  'form.currency': 'Valūta',
  'form.date': 'Datums',
  'form.description': 'Apraksts',
  'form.notes': 'Piezīmes',
  'form.type': 'Tips',
  'form.period': 'Periods',
  'form.year': 'Gads',
  'form.required': 'Obligāts',
  'form.optional': 'Neobligāts',

  // Table Headers
  'table.fund': 'Fonds',
  'table.commitment': 'Apņemšanās',
  'table.called': 'Pieprasīts',
  'table.distributed': 'Sadalīts',
  'table.tvpi': 'TVPI',
  'table.status': 'Statuss',
  'table.regulation': 'Regulējums',
  'table.filingType': 'Iesnieguma tips',
  'table.reportingPeriod': 'Periods',
  'table.createdAt': 'Izveidots',
  'table.actions': 'Darbības',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'ES Taksonomija',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Datu pilnīgums',
  'compliance.nextDeadline': 'Nākamais termiņš',

  // Reports
  'report.quarterly': 'Ceturkšņa atskaite',
  'report.annual': 'Gada atskaite',
  'report.paiStatement': 'PAI Paziņojums',
  'report.taxonomyReport': 'Taksonomijas atskaite',
  'report.generatedAt': 'Ģenerēts',
  'report.version': 'Versija',

  // General
  'general.loading': 'Ielādē...',
  'general.noData': 'Nav pieejamu datu',
  'general.error': 'Radās kļūda',
  'general.retry': 'Mēģināt vēlreiz',
  'general.total': 'Kopā',
  'general.page': 'Lapa',
  'general.of': 'no',
  'general.showing': 'Rāda',
  'general.results': 'rezultāti',
  'general.language': 'Valoda',
  'general.english': 'Angļu',
  'general.french': 'Franču',

  // Tour
  'tour.takeTour': 'Sakt apskati',
  'tour.skip': 'Izlaist',
  'tour.next': 'Talak',
  'tour.prev': 'Ieprieksejais',
  'tour.finish': 'Pabeigt',


  // Tour Content, Form Labels, Table Headers, Actions, Errors (i18n wiring)
  'tour.sidebarTitle': 'Navigācija',
  'tour.sidebarContent': 'Izmantojiet sānjoslu, lai pārvietotos starp portfeļa pārvaldību, ESG datu vākšanu, atbilstību, pārskatiem un analītikas rīkiem.',
  'tour.kpisTitle': 'Portfeļa pārskats',
  'tour.kpisContent': 'Šīs kartītes parāda jūsu portfeli vienā skatienā — kopējie fondi, AUM, aktīvie ieguldījumi un ieguldījumu saņēmēju skaits.',
  'tour.actionsTitle': 'Ātrās darbības',
  'tour.actionsContent': 'Izveidojiet fondus, pievienojiet ieguldījumus, uzaiciniet saņēmējus un ģenerējiet pārskatus ar vienu klikšķi.',
  'tour.languageTitle': 'Valoda',
  'tour.languageContent': 'Pārslēdzieties starp 24 oficiālajām ES valodām. Visa saskarne tiek tulkota uzreiz.',
  'tour.aiTitle': 'AI Palīgs',
  'tour.aiContent': 'Uzdodiet jautājumus par savu portfeli jebkurā laikā. AI palīgam ir pilns konteksts par jūsu fondiem un ieguldījumiem.',
  'action.createFund': 'Izveidot fondu',
  'action.editFund': 'Rediģēt fondu',
  'action.addInvestment': 'Pievienot ieguldījumu',
  'action.addInvestee': 'Pievienot saņēmēju',
  'action.editInvestee': 'Rediģēt saņēmēju',
  'action.createTemplate': 'Izveidot veidni',
  'action.createSubmission': 'Izveidot iesniegumu',
  'action.createFiling': 'Izveidot iesniegumu',
  'action.generateReport': 'Ģenerēt pārskatu',
  'action.inviteUser': 'Uzaicināt lietotāju',
  'action.sendInvitation': 'Nosūtīt ielūgumu',
  'action.saveChanges': 'Saglabāt izmaiņas',
  'form.fundName': 'Fonda nosaukums',
  'form.fundCode': 'Fonda kods',
  'form.sfdrCategory': 'SFDR Kategorija',
  'form.baseCurrency': 'Bāzes valūta',
  'form.targetSize': 'Mērķa lielums',
  'form.vintageYear': 'Dibināšanas gads',
  'form.geographyFocus': 'Ģeogrāfiskais fokuss',
  'form.sectorFocus': 'Nozares fokuss',
  'form.investmentCode': 'Ieguldījuma kods',
  'form.instrumentType': 'Instrumenta veids',
  'form.maturityDate': 'Dzēšanas datums',
  'form.sector': 'Nozare',
  'form.countryCode': 'Valsts kods',
  'form.entityType': 'Uzņēmuma veids',
  'form.region': 'Reģions',
  'form.staffCount': 'Darbinieku skaits',
  'form.borrowers': 'Aizņēmēji',
  'form.contactName': 'Kontaktpersonas vārds',
  'form.contactEmail': 'Kontakta e-pasts',
  'form.templateName': 'Veidnes nosaukums',
  'form.templateType': 'Veidnes veids',
  'form.indicators': 'Rādītāji',
  'form.reportingPeriod': 'Pārskata periods',
  'form.reportingYear': 'Pārskata gads',
  'form.regulation': 'Regulējums',
  'form.filingType': 'Iesnieguma veids',
  'form.reportType': 'Pārskata veids',
  'form.emailAddress': 'E-pasta adrese',
  'form.role': 'Loma',
  'form.selectFund': 'Izvēlieties fondu...',
  'form.selectInvestee': 'Izvēlieties saņēmēju...',
  'table.code': 'Kods',
  'table.investee': 'Saņēmējs',
  'table.instrument': 'Instruments',
  'table.amount': 'Summa',
  'table.currency': 'Valūta',
  'table.maturity': 'Dzēšana',
  'table.name': 'Nosaukums',
  'table.country': 'Valsts',
  'table.type': 'Veids',
  'table.period': 'Periods',
  'table.completion': 'Pabeigšana',
  'table.submitted': 'Iesniegts',
  'table.version': 'Versija',
  'table.indicators': 'Rādītāji',
  'table.dueDate': 'Termiņš',
  'table.generated': 'Ģenerēts',
  'table.email': 'E-pasts',
  'table.role': 'Loma',
  'error.createFailed': 'Izveide neizdevās. Lūdzu, mēģiniet vēlreiz.',
  'error.updateFailed': 'Atjaunināšana neizdevās. Lūdzu, mēģiniet vēlreiz.',
  'error.loadFailed': 'Datu ielāde neizdevās.',

  // Sidebar Sections
  'sections.portfolio': 'PORTFELIS',
  'sections.dataCollection': 'DATU VĀKŠANA',
  'sections.intelligence': 'IZLŪKOŠANA',
  'sections.ecosystem': 'EKOSISTĒMA',
  'sections.admin': 'ADMINISTRĒŠANA',
  'sections.other': 'CITS',

  // Page Titles
  'pages.messagesTitle': 'Ziņojumi',
  'pages.taxonomyTitle': 'ES Taksonomija',
  'pages.biStudioTitle': 'BI Studio',
  'pages.knowledgeGraphTitle': 'Zināšanu grafiks',
  'pages.benchmarksTitle': 'Etaloni',
  'pages.mcpTitle': 'MCP integrācija',
  'pages.tasksTitle': 'Uzdevumi',
  'pages.submitDataTitle': 'Iesniegt ESG datus',

  // Empty States
  'empty.benchmarksComingSoon': 'Etaloni drīzumā',

  // Labels
  'labels.sfdr': 'SFDR',
  'labels.euTaxonomy': 'ES Taksonomija',
  'labels.csrd': 'CSRD',
  'labels.mifid': 'MiFID',
  'labels.other': 'Cits',
  'labels.critical': 'Kritisks',
  'labels.high': 'Augsts',
  'labels.medium': 'Vidējs',
  'labels.low': 'Zems',

  // Count / summary strings
  'count.fundsTotal': '{count} fund(s) total',
  'count.investmentsTotal': '{count} investment(s) total',
  'count.investeesTotal': '{count} investee(s) total',

  // Filter options
  'filter.allStatus': 'All Status',
  'filter.allSfdr': 'All SFDR',

  // Empty states
  'empty.noFundsYet': 'No funds yet. Create your first fund.',
  'empty.noFundsMatch': 'No funds match your filters.',
  'empty.noInvestmentsYet': 'No investments yet.',
  'empty.noInvestmentsMatch': 'No investments match your search.',
  'empty.noInvesteesYet': 'No investees yet.',
  'empty.noInvesteesMatch': 'No investees match your search.',
  'empty.noTemplatesYet': 'No ESG templates configured yet.',
  'empty.noSubmissionsYet': 'No ESG submissions yet.',
  'empty.noComplianceData': 'No SFDR compliance data available.',
  'empty.noFilingsYet': 'No compliance filings yet.',
  'empty.noReportsYet': 'No reports generated yet.',
  'empty.selectFundPai': 'Select a fund to view PAI indicators.',
  'empty.noPaiIndicators': 'No PAI indicators found for this fund.',
  'empty.selectFundCalendar': 'Select a fund to view compliance calendar.',
  'empty.noCalendarEvents': 'No upcoming events for this fund.',

  // Page subtitles
  'subtitle.esg': 'Templates and data submissions',
  'subtitle.compliance': 'SFDR, PAI indicators, and regulatory filings',
  'subtitle.reports': 'Generate and manage compliance reports',
  'subtitle.settings': 'Manage your account and preferences',

  // Tab labels
  'tab.templates': 'Templates',
  'tab.submissions': 'Submissions',
  'tab.sfdr': 'SFDR',
  'tab.paiIndicators': 'PAI Indicators',
  'tab.filings': 'Filings',
  'tab.reports': 'Reports',
  'tab.calendar': 'Calendar',

  // Compliance table headers
  'table.indicator': 'Indicator',
  'table.category': 'Category',
  'table.metric': 'Metric',
  'table.value': 'Value',
  'table.mandatory': 'Mandatory',
  'table.data': 'Data',
  'table.deadline': 'Deadline',
  'table.taxonomy': 'Taxonomy',

  // Yes/No
  'general.yes': 'Yes',
  'general.no': 'No',

  // Error messages
  'error.loadTemplates': 'Failed to load templates.',
  'error.loadSubmissions': 'Failed to load submissions.',
  'error.loadCompliance': 'Failed to load compliance data.',
  'error.loadPai': 'Failed to load PAI indicators.',
  'error.loadFilings': 'Failed to load filings.',
  'error.loadCalendar': 'Failed to load calendar events.',
  'error.createTemplate': 'Failed to create template. Please try again.',
  'error.createSubmission': 'Failed to create submission. Please try again.',
  'error.createFiling': 'Failed to create filing. Please try again.',
  'error.generateReport': 'Failed to generate report.',
  'error.templateNameRequired': 'Template name is required',
  'error.selectFund': 'Select a fund',
  'error.selectInvestee': 'Select an investee',
  'error.validAmount': 'Enter a valid amount',
  'error.reportingPeriodRequired': 'Reporting period is required',
  'error.validYearRequired': 'Valid year is required',
  'error.enterPeriod': 'Enter a period',
  'error.nameRequired': 'Name is required',
  'error.countryCodeRequired': 'Country code is required',
  'error.operationFailed': 'Operation failed.',
  'error.pleaseselectFund': 'Please select a fund',

  // Success messages
  'success.submissionCreated': 'Submission created successfully.',
  'success.profileSaved': 'Profile saved successfully.',

  // Relative time
  'time.justNow': 'Just now',
  'time.minutesAgo': '{count}m ago',
  'time.hoursAgo': '{count}h ago',
  'time.daysAgo': '{count}d ago',

  // Settings
  'settings.profile': 'Profile',
  'settings.organization': 'Organization',
  'settings.apiKeys': 'API Keys',
  'settings.notifications': 'Notifications',
  'settings.orgId': 'Org ID',
  'settings.tier': 'Tier',
  'settings.apiKeysDescription': 'Contact your organization administrator to manage API keys and integration credentials.',
  'settings.apiKeysNote': 'API keys provide programmatic access to Impact Core data. For security, key creation and revocation is restricted to organization admins.',
  'settings.notifReportAlerts': 'Report generation alerts',
  'settings.notifReportAlertsDesc': 'Email when a report is generated or fails',
  'settings.notifComplianceReminders': 'Compliance deadline reminders',
  'settings.notifComplianceRemindersDesc': 'Email reminders for upcoming filing deadlines',
  'settings.notifEsgUpdates': 'ESG submission updates',
  'settings.notifEsgUpdatesDesc': 'Email when investee submissions change status',
  'settings.notifInAppActivity': 'In-app activity feed',
  'settings.notifInAppActivityDesc': 'Show real-time activity notifications in header',

  // Data Completeness label
  'compliance.dataCompletenessLabel': 'Data Completeness',
};
